import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MonasteryCard from '../components/MonasteryCard';
import { MonasteryGridSkeleton, EmptyState } from '../components/ui';
import { useBooking } from '../context/BookingContext';
import { api } from '../lib/api';

export default function Saved() {
  const { t } = useTranslation();
  const { savedIds } = useBooking();
  const [monasteries, setMonasteries] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    api
      .saved(controller.signal)
      .then(({ monasteries: list }) => setMonasteries(list))
      .catch(() => setMonasteries([]));
    return () => controller.abort();
  }, [savedIds.length]);

  return (
    <div className="shell" style={{ paddingBlock: 'var(--space-3xl) var(--space-5xl)' }}>
      <header className="stack" style={{ marginBottom: 'var(--space-2xl)' }}>
        <p className="eyebrow">{t('saved.eyebrow', 'My Monasteries')}</p>
        <h1 className="display display--lg">{t('saved.title', 'Monasteries you follow')}</h1>
      </header>

      {monasteries == null ? (
        <MonasteryGridSkeleton count={3} />
      ) : monasteries.length === 0 ? (
        <EmptyState
          icon="heart"
          title={t('saved.emptyTitle', 'Find monasteries you care about.')}
          action={<Link to="/explore" className="btn btn--primary">{t('saved.exploreMonasteries', 'Find a Monastery')}</Link>}
        >
          {t('saved.emptyBody', "Follow a monastery and we'll keep its important updates in one place.")}
        </EmptyState>
      ) : (
        <div className="grid-cards">
          {monasteries.map((monastery) => (
            <MonasteryCard key={monastery.id} monastery={monastery} listName="saved" />
          ))}
        </div>
      )}
    </div>
  );
}
